import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '../components/ui/button';
import './LegalPage.css';

export const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page-header">
        <Button 
          variant="outline" 
          onClick={() => navigate('/')}
          className="back-button"
        >
          <ArrowLeft size={20} />
          Retour
        </Button>
      </div>

      <div className="legal-page-container">
        <div className="legal-hero">
          <Shield size={48} />
          <h1>Politique de Confidentialité</h1>
          <p className="legal-date">Dernière mise à jour : Décembre 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              La société <strong>LUNETTERIE DU RUSSEY</strong> (SARL au capital social, immatriculée au RCS sous le numéro SIRET 80336325800028) 
              accorde une grande importance à la protection de vos données personnelles.
            </p>
            <p>
              La présente politique de confidentialité vous informe sur la manière dont nous collectons, utilisons, 
              stockons et protégeons vos données personnelles conformément au Règlement Général sur la Protection 
              des Données (RGPD) et à la loi Informatique et Libertés.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Responsable du Traitement</h2>
            <div className="info-box">
              <p><strong>Société :</strong> LUNETTERIE DU RUSSEY (SARL)</p>
              <p><strong>SIRET :</strong> 80336325800028</p>
              <p><strong>Adresse :</strong> 3 RUE DES RONDEYS, 25210 LE RUSSEY</p>
              <p><strong>Email :</strong> lunetteriedurussey@gmail.com</p>
              <p><strong>Téléphone :</strong> 03 81 67 90 20</p>
              <p><strong>Responsable de la protection des données :</strong> Elise ARNOUX</p>
            </div>
          </section>

          <section className="legal-section">
            <h2>3. Données Collectées</h2>
            <p>Nous collectons les données personnelles suivantes :</p>
            
            <h3>3.1 Formulaire de Prise de Rendez-vous</h3>
            <ul>
              <li><strong>Identité :</strong> Nom, prénom</li>
              <li><strong>Contact :</strong> Numéro de téléphone, adresse email (optionnel)</li>
              <li><strong>Informations médicales :</strong> Date de naissance, date de l'ordonnance ophtalmologique, type de rendez-vous souhaité</li>
            </ul>
            
            <h3>3.2 Simulateur de Validité d'Ordonnance</h3>
            <ul>
              <li>Date de naissance</li>
              <li>Date de l'ordonnance</li>
            </ul>
            <p><em>Ces données sont traitées uniquement localement dans votre navigateur et ne sont pas stockées sur nos serveurs.</em></p>

            <h3>3.3 Données de Navigation</h3>
            <p>
              Nous n'utilisons <strong>aucun cookie de suivi ou outil d'analyse statistique</strong> (pas de Google Analytics, 
              pas de cookies publicitaires). Seules des données techniques minimales peuvent être enregistrées par votre navigateur 
              pour le bon fonctionnement du site (cookies de session strictement nécessaires).
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Finalités du Traitement</h2>
            <p>Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
            <ul>
              <li><strong>Gestion des rendez-vous :</strong> Planification, confirmation et suivi de vos rendez-vous en magasin</li>
              <li><strong>Communication :</strong> Vous contacter pour confirmer ou modifier votre rendez-vous</li>
              <li><strong>Obligations légales :</strong> Conservation des données dans le cadre de nos obligations comptables et fiscales</li>
              <li><strong>Amélioration de nos services :</strong> Comprendre vos besoins pour améliorer notre accueil et nos prestations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Base Légale du Traitement</h2>
            <p>Le traitement de vos données personnelles repose sur :</p>
            <ul>
              <li><strong>Votre consentement :</strong> En remplissant le formulaire de rendez-vous, vous consentez au traitement de vos données</li>
              <li><strong>L'exécution d'un contrat :</strong> Le traitement est nécessaire à l'exécution de la prestation de services que vous avez demandée</li>
              <li><strong>Intérêt légitime :</strong> Amélioration de la qualité de nos services</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Destinataires des Données</h2>
            <p>Vos données personnelles sont destinées :</p>
            <ul>
              <li><strong>Au personnel autorisé de la Lunetterie du Russey :</strong> Pour la gestion de votre rendez-vous</li>
              <li><strong>Google Calendar (usage interne uniquement) :</strong> Pour la synchronisation de nos agendas professionnels. 
              <strong>Vous n'avez pas besoin de compte Google et vos données ne sont pas partagées avec Google pour d'autres finalités.</strong></li>
            </ul>
            <p>
              Nous ne vendons, ne louons ni ne transmettons vos données personnelles à des tiers à des fins commerciales.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Durée de Conservation</h2>
            <p>Vos données personnelles sont conservées pendant :</p>
            <ul>
              <li><strong>Données de rendez-vous :</strong> 3 ans à compter de votre dernier rendez-vous</li>
              <li><strong>Données comptables :</strong> 10 ans conformément aux obligations légales</li>
            </ul>
            <p>
              Au-delà de ces périodes, vos données sont supprimées ou anonymisées de manière irréversible.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Sécurité des Données</h2>
            <p>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données 
              personnelles contre la perte, l'utilisation abusive, l'accès non autorisé, la divulgation, l'altération ou la destruction :
            </p>
            <ul>
              <li>Chiffrement des connexions (HTTPS)</li>
              <li>Accès restreint aux données (personnel autorisé uniquement)</li>
              <li>Sauvegardes régulières</li>
              <li>Mises à jour de sécurité régulières</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Vos Droits</h2>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul>
              <li><strong>Droit d'accès :</strong> Obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> Corriger vos données inexactes ou incomplètes</li>
              <li><strong>Droit à l'effacement (« droit à l'oubli ») :</strong> Supprimer vos données dans certaines conditions</li>
              <li><strong>Droit à la limitation du traitement :</strong> Restreindre temporairement l'utilisation de vos données</li>
              <li><strong>Droit à la portabilité :</strong> Récupérer vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> Vous opposer au traitement de vos données pour des raisons légitimes</li>
              <li><strong>Droit de retirer votre consentement :</strong> À tout moment, sans affecter la liceité des traitements antérieurs</li>
            </ul>
            <p>
              Pour exercer vos droits, contactez-nous par email à <strong>lunetteriedurussey@gmail.com</strong> ou par courrier à :
            </p>
            <div className="info-box">
              <p>LUNETTERIE DU RUSSEY</p>
              <p>Elise ARNOUX - Responsable des données</p>
              <p>3 RUE DES RONDEYS</p>
              <p>25210 LE RUSSEY</p>
            </div>
            <p>
              Nous répondrons à votre demande dans un délai d'un mois maximum. En cas de refus, nous vous en indiquerons les motifs.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Réclamation</h2>
            <p>
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la 
              Commission Nationale de l'Informatique et des Libertés (CNIL) :
            </p>
            <div className="info-box">
              <p><strong>CNIL</strong></p>
              <p>3 Place de Fontenoy - TSA 80715</p>
              <p>75334 PARIS CEDEX 07</p>
              <p>Téléphone : 01 53 73 22 22</p>
              <p>Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>
            </div>
          </section>

          <section className="legal-section">
            <h2>11. Modifications</h2>
            <p>
              Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. 
              Toute modification sera publiée sur cette page avec une nouvelle date de mise à jour.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contact</h2>
            <p>Pour toute question concernant cette politique de confidentialité, contactez-nous :</p>
            <div className="info-box">
              <p><strong>Email :</strong> lunetteriedurussey@gmail.com</p>
              <p><strong>Téléphone :</strong> 03 81 67 90 20</p>
              <p><strong>Adresse :</strong> 3 RUE DES RONDEYS, 25210 LE RUSSEY</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};